import { render, staticRenderFns } from "./WebPrice.vue?vue&type=template&id=5cc6b06d&"
import script from "./WebPrice.vue?vue&type=script&lang=js&"
export * from "./WebPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports